import React from "react";
import Grid from "../Grid/grid";
import { motion } from "framer-motion";

function BlogHeaderSection({
  title,
  message,
}: {
  title: string;
  message: string;
}) {
  return (
    <div>
      <Grid direction="top-center" size={100} />
      <motion.div
        className="flex flex-col flex-wrap items-center justify-center gap-2 p-4 text-center mt-32"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h2
          className="text-6xl md:text-9xl font-semibold"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          {title}
        </motion.h2>
        <motion.p
          className="mt-4 text-lg text-gray-600 max-w-4xl"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          {message}
        </motion.p>
      </motion.div>
    </div>
  );
}

export default BlogHeaderSection;
